import axios from "axios";
import TicketDetails from "../classes/api/TicketDetails";
import TicketAnswer from "../classes/api/TicketAnswer";

/**
 * Retrieves ticket details for a specific customer and ticket.
 *
 * @async
 * @function
 * @param {string} customerId - The unique identifier of the customer.
 * @param {string} ticketId - The unique identifier of the ticket.
 * @returns {Promise<TicketDetails>} A promise that resolves to the ticket details.
 * @throws Will throw an error if the request fails or the response data is invalid.
 */
export const getTicketDetails = async (customerId: string, ticketId: string): Promise<TicketDetails> => {
    const {data} = await axios.get<TicketDetails[]>(`api/reclamation/${ticketId}?customerId=${customerId}`);

    return TicketDetails.fromJson(data);
};

/**
 * Sends an answer to a customer's support ticket.
 *
 * @async
 * @function
 * @returns {Promise<void>} A promise that resolves when the response is successfully sent.
 * @param answer
 */
export const answerTicket = async (answer: TicketAnswer): Promise<void> => {
    let data = new FormData();
    data.append('customerId', answer.getCustomerId());
    data.append('title', answer.getTitle());
    data.append('message', answer.getMessage());
    data.append('author', answer.getAuthor());
    if (answer.hasAttachement()) {
        data.append('file', answer.getAttachment());
    }
    await axios.post<void>(
        `api/reclamation/answer/${answer.getTicketId()}`,
        data,
        {
            headers: {'Content-type': 'multipart/form-data'},
        }
    );
};